export type EnvConfig = {
  host: string;
  oneEnv: string;
  baseURL: string;
  accessToken: string;
};

export function getApiOrigin() {
  if (window.location.host.match(/^localhost:333/)) {
    // dev local
    return 'https://sydle-dev.sydle.one/';
  }

  return window.location.origin + '/';
  // const oneOrigin = window['@sydle/blog']?.oneOrigin;
  // return oneOrigin;
}

export function getBaseURL() {
  const oneApplication = window['@sydle/site']?.oneApplication;
  return getApiOrigin() + `api/1/${oneApplication}/`;
}

export function getOrg() {
  const oneOrg = window['@sydle/site']?.oneOrg;
  return oneOrg;
}
